import classNames from 'classnames';
import { IWebcamItem, WebcamType } from 'api/region/types';
import { NextLink } from 'components/blocks/NextLink';
import { SvgLinkTr } from 'components/icons';
import { getLang } from 'i18n/locale';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { OneTrustCategories } from 'onetrust/constants';
import { RefObject, useRef } from 'react';
import { formatAsTodYestTomExact } from 'util/formatAgo';
import { useOneTrustIframe } from 'util/useAddOneTrustIframe';
import { useResponsiveImage } from 'util/useResponsiveImage';
import { BLUR_CONTENT_STYLE_NAME } from 'theme';
import styles from './styles.module.scss';
import CameraViewTitle from './CameraViewTitle';

export interface IPropsFeaturedCamera {
  cam?: IWebcamItem,
  linkBadge?: {
    title: string,
    href: string
  },
  href?: string,
  title?: string,
  badge?: string,
  isFresh: boolean,
  refScroll?: RefObject<HTMLDivElement>,
  className?: string,
  header?: string,
}

export const FeaturedCamera = (
  {
    title, cam, badge, href, linkBadge, isFresh, refScroll, className, header,
  }: IPropsFeaturedCamera,
) => {
  const { t } = useOTSTranslation('common');
  const bgImage = useResponsiveImage(cam?.image || cam?.thumbnail || '', cam?.thumbnail || '');
  let videoStream = cam?.videoStream;
  if (videoStream && cam?.webcamType === WebcamType.Feratel) {
    videoStream += `&lg=${getLang()}`;
  }
  const videoIframe = useRef<HTMLDivElement>(null);
  useOneTrustIframe(videoIframe?.current || null, videoStream || '', title || cam?.title || '', OneTrustCategories.TargetingCookies);

  const cameraView = (
    <>
      {header && (
      <header className={classNames(
        styles.header,
        {
          [BLUR_CONTENT_STYLE_NAME]: !isFresh,
        },
      )}
      >
        <span>{header}</span>
      </header>
      )}
      <figure
        className={classNames(
          styles.box,
          {
            [BLUR_CONTENT_STYLE_NAME]: !isFresh,
            [styles.iframe]: !!videoStream,
            [styles.noTop]: !!header,
          },
          !!videoStream && cam?.webcamType === WebcamType.Feratel
            ? styles.feratel
            : styles.webcam360,
          className,
        )}
        style={{ backgroundImage: !videoStream ? `url(${bgImage})` : 'none' }}
        title={t('resort.skiReport.heroTitle')}
        ref={refScroll}
      >
        {badge && <div className={styles.badge}>{badge}</div>}
        {linkBadge && (
          <nav className={styles.allCams}>
            <NextLink href={linkBadge.href}>
              {linkBadge.title}
              <SvgLinkTr />
            </NextLink>
          </nav>
        )}
        {!!videoIframe && <div ref={videoIframe} />}
        <figcaption>
          <CameraViewTitle
            title={title || cam?.title}
            date={cam ? formatAsTodYestTomExact(cam.date, t) : t('common.na')}
            href={href}
          />
        </figcaption>
      </figure>
    </>
  );

  return href && !videoStream
    ? (
      <NextLink href={href}>
        {cameraView}
      </NextLink>
    )
    : cameraView;
};
